
export enum ParkingLocationTypeCd {
	APPT_TRAILERS = 'ApptTrailers',
	EMPTY_TRAILERS = 'EmptyTrailers',
	TRACTORS = 'Tractors',
	TRAP = 'Trap'}

